import $ from 'jquery';

const loginPanel = $('.logon-panel');
const usernameValidator = $('span[id*=rfvUserNameRequired]');

$(document).ready(() => {
  if (loginPanel.length > 0) {
    if (usernameValidator.is(':visible')) {
      usernameValidator.parent().addClass('is-not-valid');
    }
  }
});
